import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-details',
  templateUrl: './research-details.component.html',
  styleUrls: ['./research-details.component.scss']
})
export class ResearchDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
